module.exports = __webpack_public_path__ + "img/H2.9340164f.png";